import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { EventEmitter, Injectable, Output } from '@angular/core'
import { FormBuilder, FormControl, Validators } from '@angular/forms'
import { catchError, throwError } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { SnackbarService } from '../../../core/services/snackbar.service'
import { compareTwoStrings } from 'string-similarity'
import { Team } from '../../../core/models/team.model'
import { lineups } from 'src/app/core/models/positions.model'

@Injectable({
  providedIn: 'root'
})
export class MatchesService {
  constructor(
    private fb:FormBuilder, 
    private http: HttpClient,
    private snackbarService: SnackbarService
  ) {}

  readonly baseURL = environment.DOMAIN_URL+'/api/matches/'

  //ADD FORMS
  submitted: boolean = false
  isExpanded: boolean = false
  importForm = new FormControl('')
  teamForForm = this.createTeamFormGroup()
  teamAgainstForm = this.createTeamFormGroup()

  matchForm = this.fb.group({
    _id : [''],
    season: ['2024/2025',Validators.required],
    date: [new Date(),Validators.required],

    competition: ['',Validators.required],
    round: ['',Validators.required],
    /*
    stadium: this.fb.group({
      name: [''],
      attendance: [0],
      neutral: [false]
    }),
    
    referee: this.fb.control<Player | null>(null),
    host_nation: [''],
    extra_time: [false],
    penalty_shootout: [''],
    */

    for: this.teamForForm,
    against: this.teamAgainstForm
  })
  
  createTeamFormGroup(){
    return this.fb.group({
      team: this.fb.control<Team | null>(null),
      /*
      play_system: [''],
      coach: this.fb.control<Player | null>(null),
      goals: [0],
      yellow_cards: [0],
      red_cards: [0],
      */
    })
  }

  //FILTERS
  @Output() filtersSubmittedEvent = new EventEmitter<null>()

  FiltersSubmitted(){
    this.filtersSubmittedEvent.emit()
  }

  filters = this.fb.group({
    season: [''],
    match: [''],
    rival: [''],
    fromDate: this.fb.control<Date | null>(null),
    toDate: this.fb.control<Date | null>(null),
  })

  matchday = this.fb.group({
    season: ['2024/2025', Validators.required],
    competition: ['LALIGA', Validators.required],
  })

  fetchMatchList(){
    return this.http.get(this.baseURL)
    .pipe(catchError(this.errorHandler))
  }

  fetchFilteredMatchList(){
    return this.http.post(this.baseURL+'filters',this.filters.value)
    .pipe(catchError(this.errorHandler.bind(this)))
  }

  fetchMatchdayMatchList(){
    return this.http.post(this.baseURL+'filters', this.matchday.value)
    .pipe(catchError(this.errorHandler.bind(this)))
  }

  fetchSeasonMatchList(season:string){
    return this.http.post(this.baseURL+'seasonmatches', {season})
    .pipe(catchError(this.errorHandler))
  }

  fetchSeason(season:string, competition:string){
    return this.http.post(this.baseURL+'season', {season, competition})
    .pipe(catchError(this.errorHandler))
  }

  populateForm(val: any){
    const competitions = Object.keys(lineups)

    competitions.forEach(c=>{
      if(compareTwoStrings(val.competition.toLowerCase(), c.toLowerCase()) > 0.8) val.competition = c
    })

    this.matchForm.patchValue(val)
  }

  //API CALLS
  getItemById(id: string){
    return this.http.get<any>(`${this.baseURL}/${id}`)
    .pipe(catchError(this.errorHandler.bind(this)))
  }

  postMatch(){
    return this.http.post(this.baseURL, this.matchForm.value)
    .pipe(catchError(this.errorHandler.bind(this)))
  }

  putMatch(){
    return this.http.put(this.baseURL+this.matchForm.get('_id')?.value, this.matchForm.value)
    .pipe(catchError(this.errorHandler.bind(this)))
  }

  deleteMatch(_id:string){
    return this.http.delete(this.baseURL+_id)
    .pipe(catchError(this.errorHandler.bind(this)))
  }
  
  importMatch(){
    return this.http.post(this.baseURL+'import', {importForm: this.importForm.value})
    .pipe(catchError(this.errorHandler.bind(this)))
  }

  importRound(){
    return this.http.post(this.baseURL+'importRound', {importForm: this.importForm.value})
    .pipe(catchError(this.errorHandler.bind(this)))
  }

  //ERROR HANDLER
  private errorHandler(error: HttpErrorResponse) {
    if (error.status === 0) console.error('An error occurred:', error.error)
    else this.snackbarService.showSnackbar(error.error)
    this.submitted = false
    return throwError(() => new Error())
  }
}